import { Icon, ICONS, SteamBar } from '@bob/library'
import { AppProviderContext } from '@websrc/App/AppContext'
import { Markdown } from '@websrc/App/Components/Markdown/Markdown'
import { PrintAndShare } from '@websrc/App/Components/PrintAndShare/PrintAndShare'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { matomo } from '@websrc/App/Tracking/Matomo'
import { CSUnitPlan_SteamBar_SteamBar } from '@websrc/Typings/ContentStack'
import React, { useContext } from 'react'

import * as SC from './UnitPlanInfo.style'

export interface UnitPlanInfoProps {
  productNames: string[]
  title: string
  learningPromise?: string | null
  grade: string
  subjects: string[]
  steamBar?: CSUnitPlan_SteamBar_SteamBar[]
  hybrid?: boolean
}

export const UnitPlanInfo = ({
  productNames,
  title,
  learningPromise,
  grade,
  subjects,
  steamBar,
  hybrid,
}: UnitPlanInfoProps) => {
  const t = useStaticText()
  const { matomoPageTemplate } = useContext(AppProviderContext)

  return (
    <>
      <SC.ProductName>{productNames.join(', ')}</SC.ProductName>
      <SC.Title>{title}</SC.Title>
      <SC.SideBySideWrapper>
        <SC.HalfWrapper>
          {learningPromise && <Markdown markdown={learningPromise} />}
          <SC.OverviewWrapper>
            <SC.InfoWrapper>
              <Icon icon={ICONS.GRADUATE} size={20} />
              {grade}
            </SC.InfoWrapper>
            {steamBar?.map((bar, i) => (
              <SteamBar
                key={i}
                labels={{ ...t.steam }}
                values={{
                  s: bar.steam_bar.science,
                  t: bar.steam_bar.technology,
                  e: bar.steam_bar.engineering,
                  a: bar.steam_bar.arts,
                  m: bar.steam_bar.math,
                }}
              />
            ))}
            {hybrid && (
              <SC.InfoWrapper>
                <Icon icon={ICONS.DISPLAY} size={20} />
                {t.plans_lessons_worksheets.hybrid}
              </SC.InfoWrapper>
            )}
          </SC.OverviewWrapper>
        </SC.HalfWrapper>
        <SC.HalfWrapper>
          <SC.LessonSubjects>{subjects.join(', ')}</SC.LessonSubjects>
          <PrintAndShare
            onPrint={() =>
              matomo.trackEvent(
                'engagement',
                matomoPageTemplate,
                [title],
                [t.print_and_share.print_button],
                'button'
              )
            }
            onShare={() =>
              matomo.trackEvent(
                'engagement',
                matomoPageTemplate,
                [title],
                [t.print_and_share.share_button],
                'button'
              )
            }
          />
        </SC.HalfWrapper>
      </SC.SideBySideWrapper>
    </>
  )
}
